import { ResponsiveSection, Text, Stack, Box } from '@stitch-fix/mode-react';
import type { GetStaticProps, NextPage } from 'next';
import { Link } from '@stitch-fix/sf-next';
import { Layout } from '../../components/Layout';
import { SEOData } from '../../components/SEOData';
import { sitemapData } from './data';

export type SitemapItem = { text: string; href: string };

export type SitemapPageProps = {
  items: [string, SitemapItem[]][];
};

export const getStaticProps: GetStaticProps<SitemapPageProps> = async () => {
  return {
    props: {
      items: [...sitemapData.entries()],
    },
  };
};

const SitemapPage: NextPage<SitemapPageProps> = ({ items }) => {
  return (
    <Layout viewEventTrackingName="corporate">
      <ResponsiveSection py="2rem" width="large">
        <SEOData
          title="Sitemap | Clothing Boxes | Stitch Fix"
          canonicalUrl="https://www.stitchfix.com/sitemap"
        />
        <Text setting="title-large" spacingBottom>
          Sitemap
        </Text>

        {items.map(([category, links], index) => (
          <Stack as="ul" key={category || index} spacing={0}>
            <Box>
              {category && (
                <Text setting="title-small" mt="1rem" spacingBottom>
                  {category}
                </Text>
              )}
              <Box as="ul" pl="2.5rem">
                {links.map(link => (
                  <Text
                    key={link.href}
                    setting="body-medium"
                    as="li"
                    style={{ listStyle: 'disc', display: 'list-item' }}
                  >
                    <Link href={link.href}>{link.text}</Link>
                  </Text>
                ))}
              </Box>
            </Box>
          </Stack>
        ))}
      </ResponsiveSection>
    </Layout>
  );
};

export default SitemapPage;
